import type { FaceData } from '../../src/ExpoOpticalMeasure.types'

type ShFinalResultData = Pick<FaceData, 'freeze' | 'sh' | 'shCapture'>

/**
 * Review may only present a result backed by the current capture's settled
 * final rerun. The rerun itself is best-effort — a rejected or failed one keeps
 * the accepted live result — so this checks that the freeze has settled, not
 * which detection won it.
 */
export const isAuthoritativeShResult = (
  incoming: ShFinalResultData,
  expectedSessionId: number | null
) => {
  const isCurrentCompletedCapture =
    expectedSessionId != null &&
    incoming.shCapture?.sessionId === expectedSessionId &&
    incoming.shCapture.phase === 'complete'

  return (
    isCurrentCompletedCapture &&
    incoming.freeze?.active === true &&
    incoming.freeze.mode === 'sh' &&
    incoming.freeze.source === 'latest-good' &&
    incoming.freeze.processing !== true &&
    incoming.freeze.finalDetection === true &&
    incoming.sh != null
  )
}
